import type {MenuItemConfig} from '@myparcel-frontend/ui';
import {Dashboard} from '@myparcel-frontend/icons/legacy';
import {markRaw} from 'vue';

export const getDashboardMenu = (): MenuItemConfig => {
  return {
    type: 'parent',
    label: 'dashboard.title',
    icon: markRaw(Dashboard),
    children: [
      {
        type: 'internal',
        to: {
          name: 'dashboard',
        },
        label: 'overview',
      },
      {
        type: 'internal',
        activeRouteNameAliases: ['analytics-dashboard'],
        to: {
          name: 'insights',
        },
        label: 'analytics.title',
      },
    ],
  };
};
